import React, { useEffect, useState } from "react";
import { Space, Table, Tag } from "antd";
import search from "../../../../assets/img/icons/search-normal.svg";
import trash from "../../../../assets/img/dashboard/trash.svg";
import edit from "../../../../assets/img/admin/edit-2.svg";
import profile from "../../../../assets/img/Home/profile.png";
import IconBox from "../../../shared/IconBox";
import { Select } from "antd";
import Selectbox from "../../../shared/Select";
import PersianNumber from "../../../shared/PersianNumber";
import moment from "jalali-moment";
import useFetch from "../../../../hooks/useAxios";
import toast from "react-hot-toast";
import BeatLoader from "react-spinners/BeatLoader";
const { Option } = Select;
const roleOption = [
  {
    label: "مهمان",
    value: "guest"
  },
  {
    label: "ادمین",
    value: "admin"
  },
  {
    label: "میزبان",
    value: "host"
  }
];

const UserTable = ({ userList, apiGetHomeInfo,setsearchParams,searchParams }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [userId, setuserId] = useState();
  const [ActiveuserId, setActiveuserId] = useState();

  const onSelectChange = newSelectedRowKeys => {
    //console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const columns = [
    {
      title: "اطلاعات کاربری",
      dataIndex: "first_name",
      key: "first_name ",
      render: (text, record, index) => {
        return (
          <div className="admin-profile flex gap-[8px] items-center">
            {record.medias.length > 0
              ? <img alt="profile" src={record.medias[0].path} />
              : null}
            <div>
              <p className="name">
                {record.first_name} {record.last_name}
              </p>
              <p className="role">
                {record.phone}
              </p>
            </div>
          </div>
        );
      }
    },
    {
      title: "نقش کاربر",
      dataIndex: "roles",
      key: "roles",
      render: (row, record) => {
        console.log(row);

        return (
          <div className="Admin-select">
            <Selectbox
              value={row.length > 0 ? row[0].name : null}
              placeholder="تعیین کنید"
              option={roleOption}
              className={``}
              onChange={value => {
                handleChangerole(value);
                setuserId(record.id);
              }}
            />
          </div>
        );
      }
    },
    {
      title: "کد ملی",
      dataIndex: "national_code",
      key: "national_code",
      render: row => {
        return (
          <div className="py-[5px] px-[38px] bg-[#F0F0F0] w-max rounded-[8px] idcode">
            {row ? <PersianNumber number={row} /> : null}
          </div>
        );
      }
    },
    {
      title: "تاریخ عضویت",
      key: "created_at",
      dataIndex: "created_at",
      render: row => {
        return (
          <div>
            {moment(row, "YYYY/MM/DD").locale("fa").format("DD  MMMM  YYYY")}
          </div>
        );
      }
    },
    {
      title: "وضعیت کاربر",
      key: "active",
      render: row =>
        <div
          className={`py-[2px] px-[10px] cursor-pointer ${row.active === 1
            ? "bg-[#189A35]"
            : "bg-[#e93131]"} text-[#fff] rounded-[6px] w-max text-center status`}
        >
          <div>
            {row.active === 1 ? "تایید شده" : "تایید نشده"}
          </div>
        </div>
    },
    {
      title: " ",
      key: "active",
      render: (row, record) => {
        console.log("row", row);
        return (
          <button
            onClick={() => setActiveuserId(row.id)}
            className={`py-[2px] w-[70px] px-[10px] ${row.active === 0
              ? "bg-[#189A35]"
              : "bg-[#e93131]"} text-[#fff] rounded-[6px] w-max text-center status`}
          >
           
            {apiAtivateUser.loading && row.id === ActiveuserId
              ? <div>
                  <BeatLoader
                    color="#36d7b7"
                    size={5}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </div>
              : <div>
                  {row.active === 1 ? "رد" : "تایید"}
                </div>}
          </button>
        );
      }
    },
    {
      title: () => {
        return (
          <div className="flex justify-end AdminSearch">
           
          <input onChange={(e)=>Searchparams(e)} placeholder="جستجو..."/>
          <IconBox  smallxss white>
              <img src={search} />
            </IconBox>
        
          </div>
        );
      },
      width: "100px",

      key: "Action",
      render: (_, { tags }) =>
        <div className="flex gap-[18px] justify-center">
          <button>
            <img src={trash} />
          </button>
          <button className="w-[34px] h-[34px] rounded-[8px] center bg-[#E9EBED]">
            <img src={edit} />
          </button>
        </div>
    }
  ];
  const Searchparams = e => {
    if (e.target.value.length >= 3) {
      setsearchParams(e.target.value);
    }else
    if(e.target.value.length===0){
      setsearchParams(undefined)
    
    }
  };
  useEffect(
    () => {
      if (searchParams !== null ) {
        apiGetHomeInfo.reFetch();
      }
     
    },
    [searchParams]
  );
  
  const [rolename, setrolename] = useState();
  const [OpenSearch, setOpenSearch] = useState(false);
  const apipostchangerole = useFetch({
    method: "post",
    url: `api/admin/users/${userId}/change-role`,
    noHeader: false,
    data: {
      role: rolename
    },
    caller: apiGetHomeInfo,
    argFunc: res => {
      toast.success(res.message);
    }
  });
  const apiAtivateUser = useFetch({
    method: "post",
    url: `api/admin/users/${ActiveuserId}/activate`,
    noHeader: false,

    caller: apiGetHomeInfo,
    argFunc: res => {
      toast.success(res.message);
    }
  });
  const handleChangerole = (role, userid) => {
    setrolename(role);
  };
  useEffect(
    () => {
      if (rolename) {
        apipostchangerole.reFetch();
      }
    },
    [rolename]
  );
  useEffect(
    () => {
      if (ActiveuserId) {
        apiAtivateUser.reFetch();
      }
    },
    [ActiveuserId]
  );
  return (
    <div className="UserTable mt-[40px]">
      <Table

        pagination={true}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={userList}
      />
    </div>
  );
};

export default UserTable;

// render: (_, { tags }) => (
//   <>
//     {tags.map((tag) => {
//       let color = tag.length > 5 ? 'geekblue' : 'green';
//       if (tag === 'loser') {
//         color = 'volcano';
//       }
//       return (
//         <Tag color={color} key={tag}>
//           {tag.toUpperCase()}
//         </Tag>
//       );
//     })}
//   </>
// ),
